import { useMemo } from "react";
import { useTranslation } from "@arc/i18n";
import { formatCurrency, formatDate, formatFromNano, formatRelativeTime, formatTime, formatTokenValue, formatToNano, } from "../utils/format";
export const useFormatter = () => {
    const { i18n } = useTranslation();
    const { language } = i18n;
    return useMemo(() => ({
        formatCurrency: (price) => formatCurrency(price, language),
        formatTokenValue: (value) => formatTokenValue(value, language),
        formatFromNano: (value, decimals = 9) => formatFromNano(value, decimals),
        formatToNano: (value, decimals = 9) => formatToNano(value, decimals),
        formatDate: (date, detailed = true, options = {}) => formatDate(date, detailed, options, language),
        formatTime: (date, options = {}) => formatTime(date, options, language),
        formatRelativeTime: (date) => formatRelativeTime(date, language),
    }), [language]);
};
//# sourceMappingURL=useFormatter.js.map